import React, {Fragment, useRef, useState, useEffect, FormEvent, useCallback} from 'react';
import './index.css';
import Button from "./components/Button/Button";
import Body from "./layout/Body/Body";
import Success from "./components/Success/Success";
import {KeySolver} from "./KeySolver";
import Input from "./components/Input/Input";
import {Route, Routes} from "react-router-dom";
import Survey from "./components/Survey/Survey";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'
import { GlobalStateProvider } from "./GlobalStateProvider";

const App: React.FC = () => {

    const [configuration, setConfiguration] = useState({api: {get: '', submit: ''}, content: { assets: { brand: ''}, welcome: '', footer: [], success: ''}, colors: { header: { background: '', text: ''}, footer: { background: '', text: ''}, button: { default: { background: '', text: ''}, hover: { background: '', text: ''}}}, csrfToken: ''});
    const [welcome, setWelcome] = useState(true);
    const [success, setSuccess] = useState(false);
    const form = useRef<HTMLFormElement>(null);

    const [firstLoad, setFirstLoad] = useState(true);
    const [name, setName] = useState('');
    const [mail, setMail] = useState('');
    const [mailValidated, setMailValidated] = useState(false);
    const [redirectUri, setRedirectUri] = useState<string|null>(null);

    const apiUrl = process.env.REACT_APP_API_URL;

    const fetchConfiguration = useCallback(() => {
        fetch(`${apiUrl}/survey/api/configuration`, {method: 'GET', redirect: 'follow'})
            .then(response => response.json())
            .then(result => {
                console.log(result);
                setConfiguration(result);
            })
            .catch(error => console.log('error', error));
    }, [apiUrl]);

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {

        event.preventDefault();
        const formElement = event.currentTarget;
        const formData = new FormData(formElement);
        // const requestHeaders = new Headers();
        // requestHeaders.append('X-Flow-Csrftoken', configuration.csrfToken);
        // console.log(configuration.csrfToken)

        fetch(`${apiUrl}${configuration.api.submit}`, {method: 'POST', redirect: 'follow', body: formData, credentials: 'include'})
            .then(response => response && response.json())
            .then(result => {
                console.log(result);
                if(result) {
                    setSuccess(true);
                    if(result && result.response) {
                        setRedirectUri(result.response);
                        // setTimeout(() => {
                        //     window.location.replace(result.response);
                        // }, 2000);
                    }
                }
            })
            .catch(error => {
                console.log('error', error)
                // setSuccess(true);
            });
    }

    const validateMailAddress = (value: string) => {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(pattern.test(value)) {
            setMail(value);
            setMailValidated(true);
        } else {
            setMail(value);
            setMailValidated(false);
        }
    }

    const startSurvey = () => {
        localStorage.setItem('name', name);
        localStorage.setItem('mail', mail);
        setWelcome(false)
    }

    useEffect(() => {
        fetchConfiguration();

        const localStorageName: string|null = localStorage.getItem('name');
        const localStorageMail: string|null = localStorage.getItem('mail');

        if(localStorageName !== null && localStorageMail !== null) {
            setName(localStorageName)
            setMail(localStorageMail);
            validateMailAddress(localStorageMail)
            setFirstLoad(false);
        }
    }, [fetchConfiguration]);

    return (
        <div className="App">

            <GlobalStateProvider>

                {configuration && configuration.csrfToken !== '' ?
                    <Fragment>

                        <style
                            dangerouslySetInnerHTML={{__html: `
                                .header { background: ${configuration.colors.header.background}; color: ${configuration.colors.header.text}; }
                                .footer { background: ${configuration.colors.footer.background}; color: ${configuration.colors.footer.text}; }
                                .button { background: ${configuration.colors.button.default.background}; color: ${configuration.colors.button.default.text}; }
                                .button:hover { background: ${configuration.colors.button.hover.background}; color: ${configuration.colors.button.hover.text}; }

                                .checkbox { border:1px solid ${configuration.colors.button.default.background}; background: none; color: ${configuration.colors.button.default.background}; }
                                .checkbox-checked { border:1px solid ${configuration.colors.button.default.background}; background: ${configuration.colors.button.default.background}; color: ${configuration.colors.button.default.text}; }
                            `}}
                        />

                        <Routes>
                            <Route key="main" path="/survey/:id" element={
                                <Fragment>

                                    <Body
                                        header={
                                            <Fragment>
                                                <div className="p-3">
                                                    <img src={configuration.content.assets.brand} className="max-w-[240px] max-h-[90px] lg:max-h-[90px]" alt="" />
                                                </div>
                                            </Fragment>
                                        }
                                        footer={
                                            <Fragment>
                                                {configuration.content.footer && configuration.content.footer.length > 0 &&
                                                    <Fragment>
                                                        <div className="flex flex-row gap-3 text-white">
                                                            {configuration.content.footer.map((item: string, i: number) =>
                                                                <Fragment key={KeySolver()} >
                                                                    <div dangerouslySetInnerHTML={{__html: item}} />
                                                                </Fragment>
                                                            )}
                                                        </div>
                                                    </Fragment>
                                                }
                                            </Fragment>
                                        }
                                    >

                                        {welcome ?
                                            <Fragment>
                                                <div className="w-full flex flex-col justify-center my-10 text-[25px] text-center" dangerouslySetInnerHTML={{__html: configuration.content.welcome}} />
                                                <div className="flex flex-col gap-4 justify-center max-w-[300px] w-full mx-auto">
                                                    <Input name="survey[firstname]" className="text-center" attributes={{placeholder: 'Ihr Name', autoFocus: true}} defaultValue={name !== '' ? name : ''} onChange={(p: string) => setName(p)} />
                                                    <Input name="survey[email]" className="text-center" attributes={{placeholder: 'Ihre E-Mail Adresse'}} defaultValue={mail !== '' ? mail : ''} onChange={(p: string) => validateMailAddress(p)} />
                                                    {name !== '' && mail !== '' && !firstLoad &&
                                                        <div className="flex justify-center">
                                                            <button type="button" className="border-b-[1px] text-blue-500 border-blue-500 transition-all hover:border-transparent" onClick={() => { setName(''); setMail(''); localStorage.removeItem('name'); localStorage.removeItem('mail'); } } >
                                                                Sie sind nicht {name}?
                                                            </button>
                                                        </div>
                                                    }
                                                </div>
                                                <div className={`w-full flex justify-center my-10${name !== '' && mail !== '' && mailValidated ? '' : ' pointer-events-none opacity-50'}`}>
                                                    <Button onClick={() => startSurvey()} >
                                                        Fragebogen starten
                                                    </Button>
                                                </div>
                                            </Fragment>
                                            :
                                            <Fragment>
                                                {!success ?
                                                    <Fragment>

                                                        <form ref={form} onSubmit={handleSubmit} >

                                                            <input type="hidden" name="survey[personal][name]" defaultValue={name} />
                                                            <input type="hidden" name="survey[personal][mail]" defaultValue={mail} />

                                                            <Survey />

                                                        </form>

                                                    </Fragment>
                                                    :
                                                    <Fragment>
                                                        <Success>
                                                            <div className="text-[25px] text-center">
                                                                <div dangerouslySetInnerHTML={{__html: configuration.content.success}} />
                                                            </div>
                                                            {redirectUri &&
                                                                <div className="flex w-full justify-center mt-10">
                                                                    <a href={redirectUri} className="rounded-full border-[1px] border-transparent p-4 ps-10 pe-10 transition-all font-semibold text-[1.4rem] md:text-[1.8rem] button">Weiter</a>
                                                                </div>
                                                            }
                                                        </Success>
                                                    </Fragment>
                                                }
                                            </Fragment>
                                        }

                                    </Body>

                                </Fragment>
                            } />
                        </Routes>


                    </Fragment>
                    :
                    <Fragment>
                        <div className="w-[100vw] h-[100vh] fixed left-0 top-0 flex flex-row items-center justify-center">
                            <FontAwesomeIcon icon={icon({name: 'spinner', style: 'solid'})} size="lg" className="text-gray-400 animate-spin" />
                        </div>
                    </Fragment>
                }

            </GlobalStateProvider>

        </div>
    );
}

export default App;
